import { useState } from "react";

export function usePasswordFieldToggle() {
  const [passwordIsVisible, setPasswordIsVisible] = useState<boolean>(false);

  const handleShowPasswordChange = (): void => {
    setPasswordIsVisible(!passwordIsVisible);
  };

  return { passwordIsVisible, handleShowPasswordChange };
}
